var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      'main-hide-text': _vm.sidebar
    }
  }, [_c('div', {
    staticClass: "sidebar-menu-con",
    style: ({
      width: _vm.sidebar ? _vm.closeSidebarWidth : _vm.openSidebarWidth,
      overflow: _vm.sidebar ? 'visible' : 'auto',
      background: _vm.menuTheme === 'dark' ? '#497ff7' : 'white'
    })
  }, [_c('Sidebar', {
    ref: "sidebar"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-header-con",
    style: ({
      paddingLeft: _vm.sidebar ? _vm.closeSidebarWidth : _vm.openSidebarWidth
    })
  }, [_c('Navbar', {
    attrs: {
      "menuActive": _vm.menuActive
    },
    on: {
      "select": _vm.selectMenu
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "single-page-con",
    staticStyle: {
      "background": "#fff",
      "visibility-height": "'200'"
    },
    style: ({
      left: _vm.sidebar ? _vm.closeSidebarWidth : _vm.openSidebarWidth
    })
  }, [_c('el-backtop', {
    attrs: {
      "target": ".single-page-con"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "single-page"
  }, [_c('router-view')], 1), _vm._v(" "), _c('Bottom')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27814ef4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = ysYN
// module chunks = 166